const formRules =  {
    mustExist: v => !!v || 'This field is required.'
};

export default formRules;
